import { render, staticRenderFns } from "./package-select-modal.vue?vue&type=template&id=7b6b0d9a&"
import script from "./package-select-modal.vue?vue&type=script&lang=js&"
export * from "./package-select-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "package-select-modal.vue"
export default component.exports